import { Button, ButtonVariant } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

export type RulebookAttachLoadMoreProps = {
  isVisible: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
};

const RulebookAttachLoadMore = ({ isVisible, isLoadingMore, onLoadMore }: RulebookAttachLoadMoreProps) =>
  isVisible ? (
    <Button
      variant={ButtonVariant.OUTLINED}
      className="mt-sm w-full"
      loading={isLoadingMore}
      onClick={onLoadMore}
      data-testid="RulebookAttachTargetModal-LoadMore"
    >
      <Trans i18nKey="rulebook:attach.action.loadMore" />
    </Button>
  ) : null;

export default RulebookAttachLoadMore;
